module.exports = __webpack_public_path__ + "static/media/coke.427fb668.gif";